import { ShieldCheck, Handshake, Sparkles, HeartPulse } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const pillars = [
  {
    icon: ShieldCheck,
    title: "Trust at every step",
    description: "Licensed U.S. providers and HIPAA-compliant systems protect your health data and clinical care.",
  },
  {
    icon: Handshake,
    title: "A partner, not a prescription pad",
    description: "We build lasting relationships. Your care team grows with you, not just your refill schedule.",
  },
  {
    icon: Sparkles,
    title: "Science-backed therapies",
    description: "Every protocol is grounded in clinical evidence and tailored by experienced clinicians.",
  },
  {
    icon: HeartPulse,
    title: "Whole-person focus",
    description: "Beyond weight loss. We address energy, recovery, hormonal balance, and long-term vitality.",
  },
];

const WhyElaraSection = () => {
  return (
    <section className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-champagne mb-3">
            Why Elara
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-foreground mb-4">
            Built for care that lasts.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {pillars.map((p) => (
            <Card key={p.title} className="border-border bg-card group hover:shadow-md transition-shadow">
              <CardContent className="p-6 space-y-3">
                <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center text-foreground group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <p.icon size={22} />
                </div>
                <h3 className="font-display text-lg text-foreground">{p.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{p.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyElaraSection;
